<script setup>
import { ref, defineEmits, defineExpose } from 'vue';
import { AppButton, DropdownSelectable, Input } from '@n11/so-ui-components';

const emit = defineEmits(['filterEmitter']);

const filterProductName = ref('');
const filterProductCode = ref('');
const filterStockCode = ref('');
const filterGtin = ref('');
const filterStatus = ref('');
const dropdown = ref(null);

const filterEmitter = () => {
  emit('filterEmitter', {
    productName: filterProductName.value,
    productId: filterProductCode.value,
    sellerStockCode: filterStockCode.value,
    gtin: filterGtin.value,
    status: filterStatus.value,
  });
};

const selectStatus = (e) => {
  filterStatus.value = e?.id ?? '';
};

const clearFiltersAndTable = () => {
  clearFilters();
  filterEmitter();
};

const clearFilters = () => {
  filterProductName.value = '';
  filterProductCode.value = '';
  filterStockCode.value = '';
  filterGtin.value = '';
  resetStatusDropdown();
};

const resetStatusDropdown = () => {
  filterStatus.value = '';
  dropdown.value.selectedRadioItem = null;
  dropdown.value.getRadioButtonGroupRef().selectedItem = {};
};

defineExpose({ clearFilters });
</script>

<template>
  <div>
    <p class="title">Ürünleri Filtrele</p>
    <div class="filters-box">
      <div class="filter-inputs">
        <Input
          v-model:value="filterProductName"
          id="product_name"
          label="Ürün Adı"
          type="text"
        />
        <Input
          v-model:value="filterProductCode"
          id="product_code"
          label="Ürün Kodu"
          type="text"
          :minLength="7"
          :isOnlyNumber="true"
        />
        <Input
          v-model:value="filterStockCode"
          id="stock_code"
          label="Stok Kodu"
          type="text"
        />
        <Input
          v-model:value="filterGtin"
          id="gtin_barcod"
          label="GTIN (Global Barkod)"
          type="text"
          :maxLength="14"
          :isOnlyNumber="true"
        />
      </div>

      <div class="dropdown">
        <DropdownSelectable
          ref="dropdown"
          :dropItems="[
            { id: '', name: 'Tüm İşlemler' },
            { id: 'ACCEPTED', name: 'Onayladığım Teklifler' },
            { id: 'REFUSED', name: 'Vazgeçtiğim Teklifler' },
            { id: 'WAITING_FOR_ACCEPTANCE', name: 'Onay Bekleyen Teklifler' },
          ]"
          :isShowSearch="false"
          :isRadioGroup="true"
          label="Tüm İşlemler"
          @selectedRadioItem="selectStatus"
        />
        <div class="checkbox-buttons">
          <AppButton
            secondary
            sm
            @click="clearFiltersAndTable"
            title="Temizle"
          ></AppButton>
          <AppButton
            primary
            sm
            @click="filterEmitter"
            title="Filtrele"
          ></AppButton>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/variables';
@import '@/assets/styles/utilities';

.title {
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: -0.05px;
  margin-bottom: 24px;
}

.filters-box {
  width: 100%;

  .filter-inputs {
    gap: 16px;
    display: flex;
    height: 40px;
    margin-bottom: 16px;

    input {
      display: flex;
      border-radius: 6px;
      background: $colorN00;
      padding: 12px;
      width: 20%;
      border: 0.5px solid $colorD30;

      &::placeholder {
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        color: $colorD40;
      }
    }
  }

  > .dropdown {
    display: flex;
    justify-content: space-between;

    .dropdownSelectable {
      width: 500px;
    }

    .checkbox-buttons {
      gap: 16px;
      display: flex;
      align-items: end;
      justify-content: end;

      button {
        height: 42px;
      }
    }
  }
}

.primary {
  border-radius: 4px;
  background: var(--Green---Success-G50, #5d3ebc);
  display: flex;
  height: 32px;
  padding: 7px 32px;
  justify-content: center;
  align-items: center;
  gap: 2px;
  color: #fff;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: -0.05px;
}

.secondary {
  border-radius: 4px;
  background: var($colorD30, #b3bbcb);
  display: flex;
  height: 32px;
  padding: 7px 32px;
  justify-content: center;
  align-items: center;
  gap: 2px;
  color: #fff;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: -0.05px;
}
</style>
